import type { ComponentType, LazyExoticComponent } from 'react';
import { lazy } from 'react';
import { promiseWithRetries } from 'util/retry/promise-with-retries';

// this any type matches the react typings
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const reactLazyWithRetries = <T extends ComponentType<any>>(
    factory: () => Promise<{ default: T }>
): LazyExoticComponent<T> => lazy(() => promiseWithRetries(factory, {}));
